import { toast, Notification } from 'components/ui'

function showToast({ type = 'success', message, title, duration = 2500 }) {
    toast.push(
        <Notification title={title} type={type} duration={duration}>
            {message}
        </Notification>,
        {
            placement: 'top-center',
        }
    )
}

export { showToast }
